export const TypeValidationMap = {
  BOOLEAN: (value: unknown) =>
    value === false || value === true || value === "true" || value === "false",
  NUMBER: (value: unknown) => !isNaN(value as number),
  STRING: (value: unknown) => true,
};
